<template>
    <div id="info-slider" class="carousel slide" data-ride="carousel" data-interval="false">
        <div v-show="load === true" class="loader-box inner_block">
            <div class="loader">
                <svg viewBox="25 25 50 50" class="circular">
                    <circle
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        class="path">
                    </circle>
                </svg>
            </div>
            <div class="bg-loader"></div>
        </div>
        <ol v-cloak class="carousel-indicators">
            <li
                v-for="(lection, index)  in lections"
                v-if="lections.length > 1"
                data-target="#info-slider"
                :data-slide-to="index"
                :class="{active: index === 0}">
            </li>
        </ol>
        <div class="top-line">
            <div v-cloak>
                <time v-if="lections.length > 1" class="data-theme">
                    <span class="fa fa-calendar"></span>
                    {{lections[0].start.formatted.day}} {{lections[0].start.formatted.month}},
                    {{lections[0].start.formatted.day_week}} - {{lections.length}}
                    <span>вебинары</span>
                </time>
                <time v-else-if="lections.length < 2" class="data-theme">
                    <span class="fa fa-calendar"></span>
                    {{lections[0].start.formatted.day}} {{lections[0].start.formatted.month}},
                    {{lections[0].start.formatted.day_week}} - {{lections.length}}
                    <span>вебинар</span>
                </time>
            </div>
        </div>
        <div v-cloak class="carousel-calendar carousel-inner">
            <div v-for="(lection, index)  in lections" class="carousel-calendar__item item-carousel item">
                <div class="item-carousel__wrapper">
                    <div class="item-carousel__top-info">
                        <time class="item-carousel__time time">
                            <span class="fa fa-clock-o"></span>
                            {{lection.start.formatted.time}} (МСК)
                        </time>
                        <a class="item-carousel__link theme" :href="lection._links.self.href">
                            <span>{{lection.name}}</span>
                        </a>
                        <div class="item-carousel__nmo-block nmo-block nmo-block_medium-text" v-if="lection.nmo.status === true">
                            <span class="nmo-block__label nmo-label">
                                <i
                                    class="fa fa-check nmo-block__icon left-icon nmo-block__icon_accept"
                                    v-if="lection.nmo.accredited === true">
                                </i>
                                <i
                                    class="fa fa-clock-o nmo-block__icon left-icon nmo-block__icon_expect"
                                    v-else>
                                </i>
                                HMO
                            </span>
                            <div class="nmo-block__text-info" v-if="lection.nmo.accredited === true">
                                Соответствует требованиям для НМО <span v-if="false">(N кредитов)</span>
                            </div>
                            <div class="nmo-block__text-info" v-else>
                                Документация по данному учебному мероприятию представлена
                                в Комиссию по оценке учебных мероприятий и материалов для НМО
                            </div>
                        </div>
                        <div
                            class="item-carousel__authors autor-block"
                            v-if="lection.lectors.length + lection.sponsors.length <= 2"
                            :class="{ 'min-ava': lection.lectors.length == 2 && lection.sponsor }">
                            <a :href="lector.link" v-for="lector in lection.lectors" class="autor">
                                <span class="img-h" :title="lector.name.full">
                                    <img :src="lector.photo.thumb" class="img-responsive" :alt="lector.name.full">
                                </span>
                                <span class="name-block">
                                    <span class="name">{{lector.name.full}}</span>
                                    <span class="sub-text">Спикер</span>
                                </span>
                            </a>
                            <a :href="sponsor.link" v-for="sponsor in lection.sponsors" class="partner">
                                <span class="img-h" v-bind:title="sponsor.name.full">
                                    <img :src="sponsor.photo.thumb" class="img-responsive" :alt="sponsor.name">
                                </span>
                                <span class="name-block">
                                    <span class="name">{{sponsor.name}}</span>
                                    <span class="sub-text">Партнер</span>
                                </span>
                            </a>
                        </div>
                        <div
                            class="item-carousel__authors autor-block min-ava-2"
                            v-else-if="lection.lectors.length + lection.sponsors.length > 5">
                            <a
                                :href="lector.link"
                                v-for="lector in lection.lectors"
                                class="autor">
                                <span class="img-h" :title="lector.name.full">
                                    <img :src="lector.photo.thumb" class="img-responsive" :alt="lector.name.full">
                                </span>
                                <span class="name-block">
                                    <span class="name">{{lector.name.full}}</span>
                                    <span class="sub-text">Спикер</span>
                                </span>
                            </a>
                            <a :href="sponsor.link" v-for="sponsor in lection.sponsors" class="partner">
                                <span class="img-h" v-bind:title="sponsor.name.full">
                                    <img :src="sponsor.photo.thumb" class="img-responsive" :alt="sponsor.name.full">
                                </span>
                                <span class="name-block">
                                    <span class="name">{{sponsor.name.full}}</span>
                                    <span class="sub-text">Партнер</span>
                                </span>
                            </a>
                        </div>
                        <div class="item-carousel__authors autor-block min-ava" v-else>
                            <a :href="lector.link" v-for="lector in lection.lectors" class="autor">
                                <span class="img-h" :title="lector.name.full">
                                    <img :src="lector.photo.thumb" class="img-responsive" :alt="lector.name.full">
                                </span>
                                <span class="name-block">
                                    <span class="name">{{lector.name.full}}</span>
                                    <span class="sub-text">Спикер</span>
                                </span>
                            </a>
                            <a :href="sponsor.link" v-for="sponsor in lection.sponsors" class="partner">
                                <span class="img-h" :title="sponsor.name">
                                    <img :src="sponsor.photo.thumb" class="img-responsive" :alt="sponsor.name">
                                </span>
                                <span class="name-block">
                                    <span class="name">{{sponsor.name}}</span>
                                    <span class="sub-text">Партнер</span>
                                </span>
                            </a>
                        </div>
                    </div>
                    <a
                        class="item-carousel__more-links more-links"
                        :href="lection._links.self.href">
                        <span class="text">Подробнее</span>
                        <span class="fa fa-angle-right"></span>
                    </a>
                </div>
            </div>
        </div>
        <a v-if="lections.length > 1" class="left carousel-control" href="#info-slider" data-slide="prev">
            <span v-cloak class="fa fa-angle-left"></span>
        </a>
        <a v-if="lections.length > 1" class="right carousel-control" href="#info-slider" data-slide="next">
            <span v-cloak class="fa fa-angle-right"></span>
        </a>
    </div>
</template>
<script>
    let api = {
        endpoint:'/api/v1/',
        getLections(params){
            this.request('getLections',params,this.endpoint + 'lection')
        },
        request(action,params,url) {
            for (let propName in params) {
                if (params[propName] === null || params[propName] === undefined) {
                    delete params[propName];
                }
            }
            try {

                $.ajax({
                    url: url,
                    dataType: "json",
                    data:params,
                    success: function (data) {
                        document.dispatchEvent(new CustomEvent(action, {
                            bubbles: true,
                            detail: data
                        }));
                    },
                    fail: function () {

                        throw new Error('Ошибка получении данных');

                    }
                });

            }
            catch (e) {
                //Отправить данные об ошибке в систему логов
                console.error(e);

            }
        }
    };
    export default {
        name: 'calendar-lectures',
        data() {
            return {
                requestParams: {},
                calendarNode:null,
                lections: {},
                load: true,
                lectures: null
            }
        },
        updated(){
            $("#info-slider .item").removeClass('active');
            $("#info-slider .item:first").addClass('active');
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let self = this;
                let $filterNode = $(".filter-calendar");
                this.calendarNode = $("#calendar-slider");
                $(document).on('getLections',function (event) {
                    self.setCalendar(event.detail);
                });
                $filterNode.on('click', 'li', function () {
                    let idSection = $(this).data('id');
                    $('#current-section').html($(this).text());
                    self.calendarNode.find('.day.dotted').removeClass('dotted');
                    self.requestParams = {
                        page:1,
                        months:3,
                        spec_id:idSection > 0 ? idSection:null,
                        sort:'-started_at',
                        'per-page':50
                    };
                    api.getLections(self.requestParams);
                });
                $(document).on('click',"#calendar-slider td span.dotted",function(){
                    $("#calendar-slider").find('.day.active').removeClass('active');
                    $(this).addClass('active');
                    self.setActiveLectures();
                });
                this.setActiveLectures();
            },
            setCalendar(data){
                $.each(data.items,function (i,v) {
                    let date = new Date(v.start.unix * 1000);
                    let mm = ('0' + (date.getMonth() + 1)).slice(-2);	// Months are zero based. Add leading 0.
                    let dd = ('0' + date.getDate()).slice(-2);
                    let nodeName = '#m-' + date.getFullYear() + mm + dd ;
                    $(nodeName).addClass('dotted');
                });

                while(this.requestParams.page < data._meta.pageCount){
                    $.extend(this.requestParams, {page:data._meta.currentPage + 1});
                    api.getLections(this.requestParams);
                }
                if(this.requestParams.page === data._meta.pageCount){
                    this.calendarNode.find('.day.active').removeClass('active');
                    this.calendarNode.find('.day.dotted:first').addClass('active');
                    this.setActiveLections();
                }

            },
            setActiveLectures(){
                let self = this;
                let activeDate = $('.day.dotted.active').find('time').attr('datetime');
                if($('.day.dotted.active').length <= 0){
                    activeDate = $('.item.active .day.dotted:first').find('time').attr('datetime');
                    $('.item.active .day.dotted:first').addClass('active');
                };
                this.load = true;
                $.ajax({
                    url: api.endpoint+'lection',
                    dataType: "json",
                    data:{ 'started_at':activeDate,'spec_id':self.requestParams.spec_id ? self.requestParams.spec_id:null},
                    success(data) {
                        self.lections = data.items;
                        self.load = false;
                    },
                    fail() {
                        throw new Error('Ошибка получении данных');
                    }
                });

            }
        }
    };
</script>
